export const cibKlout = ["32 32","<path d='M0 3.563v19.631h21.563l10.437 5.244v-24.875zM13.104 14.792h-1.563l-3.839 5.405h-4.567l5.249-7.020-4.849-6.761h4.448l3.547 5.177h1.573zM24.312 20.193l-3.839-5.401h-2.624v5.401h-3.641v-13.777h3.647v5.177h2.619l3.548-5.177h4.437l-4.844 6.761 5.249 7.020h-4.552z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-klout.js
// module id = null
// module chunks = 